/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   poi meta reducer
 */

import type { PoiMetaType } from '@zcode/state-type'
import type { Values } from '@zcode/utility-types'
import { combineReducers } from 'redux'
import { type ExtractActions, handleActions } from 'redux-actions'

import type * as poiActions from '../actions'
import {
  CLEAR_POI,
  DONE_FETCHING_POI,
  ERROR_FETCHING_POI,
  START_FETCHING_POI,
} from '../constants/index'
type ActionTypes = ExtractActions<Values<typeof poiActions>>

export const metaReducer = combineReducers<PoiMetaType, ActionTypes>({
  error: handleActions(
    {
      [ERROR_FETCHING_POI]: (state, { payload }) => payload?.error || state,
      [CLEAR_POI]: () => null,
      [START_FETCHING_POI]: () => null,
    },
    null as PoiMetaType['error']
  ),
  fetching: handleActions(
    {
      [START_FETCHING_POI]: () => true,
      [CLEAR_POI]: () => false,
      [DONE_FETCHING_POI]: () => false,
    },
    false as PoiMetaType['fetching']
  ),
  fetchingKey: handleActions(
    {
      [START_FETCHING_POI]: (state, { payload }) => payload?.key ?? state,
      [CLEAR_POI]: () => null,
      [DONE_FETCHING_POI]: () => null,
    },
    null as PoiMetaType['fetchingKey']
  ),
  currentKey: handleActions(
    {
      [CLEAR_POI]: () => null,
      [DONE_FETCHING_POI]: (state, { payload }) => payload?.key ?? state,
    },
    null as PoiMetaType['currentKey']
  ),
})
